import { Params } from '@angular/router';
import { IActionOptions } from '@interfaces/IActionOptions';
import { IFormErrors } from '@interfaces/IFormsErrors';
import {
  IActionDealHistory,
  IApplicants,
  IContractCredentials,
  IDealByID,
  IDealsPagination,
  IDiscount,
  IEnrollPresentationDataPagination,
  IGetTokenForLeadForm,
  ILeadData,
  ILeadDocument,
  ILeadPagination,
  ILeadQRRegisterMutation,
  ILeadStatuses,
  IPaymentFullHistory,
  IPayments,
  IPresentationInfo,
  ITaskFile,
  ITaskFull,
  ITaskWithPagination,
} from '@interfaces/ISales';
import { IUsersPagination } from '@interfaces/IUser';
import { Action } from '@ngrx/store';

export enum ESalesViewActions {
  GetTokenForLeadFormRequest = '[Sales-view] Get Token For Lead Form Request',
  GetTokenForLeadFormSuccess = '[Sales-view] Get Token For Lead Form Success',
  GetTokenForLeadFormFailure = '[Sales-view] Get Token For Lead Form Failure',
  ClearGetTokenForLeadFormErrors = '[Sales-view] Clear Get Token For Lead Form Errors',

  GetPresentationInfoRequest = '[Sales-view] Get Presentation Info Request',
  GetPresentationInfoSuccess = '[Sales-view] Get Presentation Info Success',
  GetPresentationInfoFailure = '[Sales-view] Get Presentation Info Failure',
  ClearGetPresentationInfo = '[Sales-view] Clear Get Presentation Info',

  GetEnrolleesRequest = '[Sales-view] Get Enrollees Request',
  GetEnrolleesSuccess = '[Sales-view] Get Enrollees Success',
  GetEnrolleesFailure = '[Sales-view] Get Enrollees Failure',
  ClearGetEnrollees = '[Sales-view] Clear Get Enrollees',

  GetDealHistoryRequest = '[Sales-view] Get Deal History Request',
  GetDealHistorySuccess = '[Sales-view] Get Deal History Success',
  GetDealHistoryFailure = '[Sales-view] Get Deal History Failure',
  ClearGetDealHistory = '[Sales-view] Clear Get Deal History',

  GetEnrolleesInPresentationRequest = '[Sales-view] Get Enrollees In Presentation Request',
  GetEnrolleesInPresentationSuccess = '[Sales-view] Get Enrollees In Presentation Success',
  GetEnrolleesInPresentationFailure = '[Sales-view] Get Enrollees In Presentation Failure',
  ClearGetEnrolleesInPresentation = '[Sales-view] Clear Get Enrollees In Presentation',

  GetLeadsRequest = '[Sales-view] Get Leads Request',
  GetLeadsSuccess = '[Sales-view] Get Leads Success',
  GetLeadsFailure = '[Sales-view] Get Leads Failure',
  ClearGetLeads = '[Sales-view] Clear Get Leads',

  GetLeadInQRRequest = '[Sales-view] Get Lead In QR Request',
  GetLeadInQRSuccess = '[Sales-view] Get Lead In QR Success',
  GetLeadInQRFailure = '[Sales-view] Get Lead In QR Failure',
  ClearGetLeadInQR = '[Sales-view] Clear Get Lead In QR',

  GetLeadStatusesRequest = '[Sales-view] Get Leads Statuses Request',
  GetLeadStatusesSuccess = '[Sales-view] Get Leads Statuses Success',
  GetLeadStatusesFailure = '[Sales-view] Get Leads Statuses Failure',
  ClearGetLeadStatusesErrors = '[Sales-view] Clear Get Leads Statuses Errors',

  GetLeadRequest = '[Sales-view] Get Lead Request',
  GetLeadSuccess = '[Sales-view] Get Lead Success',
  GetLeadFailure = '[Sales-view] Get Lead Failure',
  ClearGetLeadErrors = '[Sales-view] Clear Get Lead Errors',

  GetTasksRequest = '[Sales-view] Get Tasks Request',
  GetTasksSuccess = '[Sales-view] Get Tasks Success',
  GetTasksFailure = '[Sales-view] Get Tasks Failure',
  ClearGetTasksErrors = '[Sales-view] Clear Get Tasks Errors',

  GetTaskRequest = '[Sales-view] Get Task Request',
  GetTaskSuccess = '[Sales-view] Get Task Success',
  GetTaskFailure = '[Sales-view] Get Task Failure',
  ClearGetTaskErrors = '[Sales-view] Clear Get Task Errors',

  GetTaskFilesRequest = '[Sales-view] Get Task Files Request',
  GetTaskFilesSuccess = '[Sales-view] Get Task Files Success',
  GetTaskFilesFailure = '[Sales-view] Get Task Files Failure',
  ClearGetTaskFilesErrors = '[Sales-view] Clear Get Task Files Errors',

  GetContractCredentialsRequest = '[Sales-view] Get Contract Credentials Request',
  GetContractCredentialsSuccess = '[Sales-view] Get Contract Credentials Success',
  GetContractCredentialsFailure = '[Sales-view] Get Contract Credentials Failure',
  ClearGetContractCredentialsErrors = '[Sales-view] Clear Get Contract Credentials Errors',

  GetLeadDocumentsRequest = '[Sales-view] Get Lead Documents Request',
  GetLeadDocumentsSuccess = '[Sales-view] Get Lead Documents Success',
  GetLeadDocumentsFailure = '[Sales-view] Get Lead Documents Failure',
  ClearGetLeadDocumentsErrors = '[Sales-view] Clear Get Lead Documents Errors',

  GetLeadContractRequest = '[Sales-view] Get Lead Contract Request',
  GetLeadContractSuccess = '[Sales-view] Get Lead Contract Success',
  GetLeadContractFailure = '[Sales-view] Get Lead Contract Failure',
  ClearGetLeadContractErrors = '[Sales-view] Clear Get Lead Contract Errors',

  GetAllSalesDealsRequest = '[Sales-view] Get All Sales Deals Request',
  GetAllSalesDealsSuccess = '[Sales-view] Get All Sales Deals Success',
  GetAllSalesDealsFailure = '[Sales-view] Get All Sales Deals Failure',
  ClearGetAllSalesDealsErrors = '[Sales-view] Clear Get All Sales Deals Errors',

  GetOneDealByIDRequest = '[Sales-view] Get One Deal By ID Request',
  GetOneDealByIDSuccess = '[Sales-view] Get One Deal By ID Success',
  GetOneDealByIDFailure = '[Sales-view] Get One Deal By ID Failure',
  ClearGetOneDealByIDErrors = '[Sales-view] Clear Get One Deal By ID Errors',

  GetAllPaymentsRequest = '[Sales-view] Get All Payments Request',
  GetAllPaymentsSuccess = '[Sales-view] Get All Payments Success',
  GetAllPaymentsFailure = '[Sales-view] Get All Payments Failure',
  ClearGetAllPaymentsErrors = '[Sales-view] Clear Get All Payments Errors',

  GetFullViewOfPaymentRequest = '[Sales-view] Get Full View Of Payment Request',
  GetFullViewOfPaymentSuccess = '[Sales-view] Get Full View Of Payment Success',
  GetFullViewOfPaymentFailure = '[Sales-view] Get Full View Of Payment Failure',
  ClearGetFullViewOfPaymentErrors = '[Sales-view] Clear Get Full View Of Payment Errors',

  GetAllDiscountsRequest = '[Sales-view] Get All Discounts Request',
  GetAllDiscountsSuccess = '[Sales-view] Get All Discounts Success',
  GetAllDiscountsFailure = '[Sales-view] Get All Discounts Failure',

  GetApplicantsRequest = '[Sales-view] Get Applicants Request',
  GetApplicantsSuccess = '[Sales-view] Get Applicants Success',
  GetApplicantsFailure = '[Sales-view] Get Applicants Failure',
}

export class GetDealHistoryRequest implements Action {
  public readonly type = ESalesViewActions.GetDealHistoryRequest;

  constructor(public deal_id: number) {}
}

export class GetDealHistorySuccess implements Action {
  public readonly type = ESalesViewActions.GetDealHistorySuccess;

  constructor(public data: IActionDealHistory[]) {}
}

export class GetDealHistoryFailure implements Action {
  public readonly type = ESalesViewActions.GetDealHistoryFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetDealHistory implements Action {
  public readonly type = ESalesViewActions.ClearGetDealHistory;
}

export class GetTokenForLeadFormRequest implements Action {
  public readonly type = ESalesViewActions.GetTokenForLeadFormRequest;

  constructor(public options?: Params) {}
}

export class GetTokenForLeadFormSuccess implements Action {
  public readonly type = ESalesViewActions.GetTokenForLeadFormSuccess;

  constructor(public data: IGetTokenForLeadForm) {}
}

export class GetTokenForLeadFormFailure implements Action {
  public readonly type = ESalesViewActions.GetTokenForLeadFormFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetTokenForLeadFormErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetTokenForLeadFormErrors;
}

export class GetPresentationInfoRequest implements Action {
  public readonly type = ESalesViewActions.GetPresentationInfoRequest;

  constructor(public options?: IActionOptions) {}
}

export class GetPresentationInfoSuccess implements Action {
  public readonly type = ESalesViewActions.GetPresentationInfoSuccess;

  constructor(public data: IPresentationInfo | null) {}
}

export class GetPresentationInfoFailure implements Action {
  public readonly type = ESalesViewActions.GetPresentationInfoFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetPresentationInfo implements Action {
  public readonly type = ESalesViewActions.ClearGetPresentationInfo;
}

export class GetEnrolleesRequest implements Action {
  public readonly type = ESalesViewActions.GetEnrolleesRequest;

  constructor(public options?: IActionOptions) {}
}

export class GetEnrolleesSuccess implements Action {
  public readonly type = ESalesViewActions.GetEnrolleesSuccess;

  constructor(public data: IUsersPagination) {}
}

export class GetEnrolleesFailure implements Action {
  public readonly type = ESalesViewActions.GetEnrolleesFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetEnrollees implements Action {
  public readonly type = ESalesViewActions.ClearGetEnrollees;
}

export class GetEnrolleesInPresentationRequest implements Action {
  public readonly type = ESalesViewActions.GetEnrolleesInPresentationRequest;

  constructor(public options?: IActionOptions) {}
}

export class GetEnrolleesInPresentationSuccess implements Action {
  public readonly type = ESalesViewActions.GetEnrolleesInPresentationSuccess;

  constructor(public data: IEnrollPresentationDataPagination) {}
}

export class GetEnrolleesInPresentationFailure implements Action {
  public readonly type = ESalesViewActions.GetEnrolleesInPresentationFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetEnrolleesInPresentation implements Action {
  public readonly type = ESalesViewActions.ClearGetEnrolleesInPresentation;
}

export class GetLeadsRequest implements Action {
  public readonly type = ESalesViewActions.GetLeadsRequest;

  constructor(public options?: IActionOptions) {}
}

export class GetLeadsSuccess implements Action {
  public readonly type = ESalesViewActions.GetLeadsSuccess;

  constructor(public data: ILeadPagination) {}
}

export class GetLeadsFailure implements Action {
  public readonly type = ESalesViewActions.GetLeadsFailure;

  constructor(public errors: IFormErrors) {}
}

export class GetLeadInQRRequest implements Action {
  public readonly type = ESalesViewActions.GetLeadInQRRequest;

  constructor(public options?: IActionOptions) {}
}

export class GetLeadInQRSuccess implements Action {
  public readonly type = ESalesViewActions.GetLeadInQRSuccess;

  constructor(public data: ILeadQRRegisterMutation) {}
}

export class GetLeadInQRFailure implements Action {
  public readonly type = ESalesViewActions.GetLeadInQRFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetLeadInQR implements Action {
  public readonly type = ESalesViewActions.ClearGetLeadInQR;
}

export class ClearGetLeads implements Action {
  public readonly type = ESalesViewActions.ClearGetLeads;
}

export class GetLeadRequest implements Action {
  public readonly type = ESalesViewActions.GetLeadRequest;

  constructor(public id: number, public options?: IActionOptions) {}
}

export class GetLeadSuccess implements Action {
  public readonly type = ESalesViewActions.GetLeadSuccess;

  constructor(public data: ILeadData) {}
}

export class GetLeadFailure implements Action {
  public readonly type = ESalesViewActions.GetLeadFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetLeadErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetLeadErrors;
}

export class GetLeadStatusesRequest implements Action {
  public readonly type = ESalesViewActions.GetLeadStatusesRequest;
}

export class GetLeadStatusesSuccess implements Action {
  public readonly type = ESalesViewActions.GetLeadStatusesSuccess;

  constructor(public data: ILeadStatuses[]) {}
}

export class GetLeadStatusesFailure implements Action {
  public readonly type = ESalesViewActions.GetLeadStatusesFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetLeadStatusesErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetLeadStatusesErrors;
}

export class GetTasksRequest implements Action {
  public readonly type = ESalesViewActions.GetTasksRequest;

  constructor(
    public options?:
      | IActionOptions
      | { [key: string]: string | number | boolean }
  ) {}
}

export class GetTasksSuccess implements Action {
  public readonly type = ESalesViewActions.GetTasksSuccess;

  constructor(public data: ITaskWithPagination) {}
}

export class GetTasksFailure implements Action {
  public readonly type = ESalesViewActions.GetTasksFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetTasksErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetTasksErrors;
}

export class GetTaskRequest implements Action {
  public readonly type = ESalesViewActions.GetTaskRequest;

  constructor(public id: number) {}
}

export class GetTaskSuccess implements Action {
  public readonly type = ESalesViewActions.GetTaskSuccess;

  constructor(public data: ITaskFull) {}
}

export class GetTaskFailure implements Action {
  public readonly type = ESalesViewActions.GetTaskFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetTaskErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetTaskErrors;
}

export class GetTaskFilesRequest implements Action {
  public readonly type = ESalesViewActions.GetTaskFilesRequest;

  constructor(public options?: Params | IActionOptions) {}
}

export class GetTaskFilesSuccess implements Action {
  public readonly type = ESalesViewActions.GetTaskFilesSuccess;

  constructor(public data: ITaskFile[]) {}
}

export class GetTaskFilesFailure implements Action {
  public readonly type = ESalesViewActions.GetTaskFilesFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetTaskFilesErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetTaskFilesErrors;
}

export class GetContractCredentialsRequest implements Action {
  public readonly type = ESalesViewActions.GetContractCredentialsRequest;
}

export class GetContractCredentialsSuccess implements Action {
  public readonly type = ESalesViewActions.GetContractCredentialsSuccess;

  constructor(public data: IContractCredentials[]) {}
}

export class GetContractCredentialsFailure implements Action {
  public readonly type = ESalesViewActions.GetContractCredentialsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetContractCredentialsErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetContractCredentialsErrors;
}

export class GetLeadDocumentsRequest implements Action {
  public readonly type = ESalesViewActions.GetLeadDocumentsRequest;

  constructor(public lead_id: number) {}
}

export class GetLeadDocumentsSuccess implements Action {
  public readonly type = ESalesViewActions.GetLeadDocumentsSuccess;

  constructor(public data: ILeadDocument[]) {}
}

export class GetLeadDocumentsFailure implements Action {
  public readonly type = ESalesViewActions.GetLeadDocumentsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetLeadDocumentsErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetLeadDocumentsErrors;
}

export class GetLeadContractRequest implements Action {
  public readonly type = ESalesViewActions.GetLeadContractRequest;

  constructor(public lead_id: number) {}
}

export class GetLeadContractSuccess implements Action {
  public readonly type = ESalesViewActions.GetLeadContractSuccess;

  constructor(public data: string) {}
}

export class GetLeadContractFailure implements Action {
  public readonly type = ESalesViewActions.GetLeadContractFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetLeadContractErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetLeadContractErrors;
}

export class GetAllSalesDealsRequest implements Action {
  public readonly type = ESalesViewActions.GetAllSalesDealsRequest;

  constructor(public options?: Params) {}
}

export class GetAllSalesDealsSuccess implements Action {
  public readonly type = ESalesViewActions.GetAllSalesDealsSuccess;

  constructor(public data: IDealsPagination) {}
}

export class GetAllSalesDealsFailure implements Action {
  public readonly type = ESalesViewActions.GetAllSalesDealsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetAllSalesDealsErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetAllSalesDealsErrors;
}

export class GetOneDealByIDRequest implements Action {
  public readonly type = ESalesViewActions.GetOneDealByIDRequest;

  constructor(public deal_id: number) {}
}

export class GetOneDealByIDSuccess implements Action {
  public readonly type = ESalesViewActions.GetOneDealByIDSuccess;

  constructor(public data: IDealByID) {}
}

export class GetOneDealByIDFailure implements Action {
  public readonly type = ESalesViewActions.GetOneDealByIDFailure;

  constructor(public errors: IFormErrors) {}
}

export class GetAllPaymentsRequest implements Action {
  public readonly type = ESalesViewActions.GetAllPaymentsRequest;

  constructor(public queries?: Params) {}
}

export class GetAllPaymentsSuccess implements Action {
  public readonly type = ESalesViewActions.GetAllPaymentsSuccess;

  constructor(public data: IPayments) {}
}

export class GetAllPaymentsFailure implements Action {
  public readonly type = ESalesViewActions.GetAllPaymentsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetAllPaymentsErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetAllPaymentsErrors;
}

export class GetAllDiscountsRequest implements Action {
  public readonly type = ESalesViewActions.GetAllDiscountsRequest;
}

export class GetAllDiscountsSuccess implements Action {
  public readonly type = ESalesViewActions.GetAllDiscountsSuccess;

  constructor(public data: IDiscount[]) {}
}

export class GetAllDiscountsFailure implements Action {
  public readonly type = ESalesViewActions.GetAllDiscountsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetOneDealByIDErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetOneDealByIDErrors;
}

export class GetFullViewOfPaymentRequest implements Action {
  public readonly type = ESalesViewActions.GetFullViewOfPaymentRequest;

  constructor(public payment_id: number) {}
}

export class GetFullViewOfPaymentSuccess implements Action {
  public readonly type = ESalesViewActions.GetFullViewOfPaymentSuccess;

  constructor(public data: IPaymentFullHistory | null) {}
}

export class GetFullViewOfPaymentFailure implements Action {
  public readonly type = ESalesViewActions.GetFullViewOfPaymentFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetFullViewOfPaymentErrors implements Action {
  public readonly type = ESalesViewActions.ClearGetFullViewOfPaymentErrors;
}

export class GetApplicantsRequest implements Action {
  public readonly type = ESalesViewActions.GetApplicantsRequest;
}

export class GetApplicantsSuccess implements Action {
  public readonly type = ESalesViewActions.GetApplicantsSuccess;

  constructor(public data: IApplicants) {}
}

export class GetApplicantsSFailure implements Action {
  public readonly type = ESalesViewActions.GetApplicantsFailure;

  constructor(public errors: IFormErrors) {}
}

export type SalesViewActions =
  | GetTokenForLeadFormRequest
  | GetTokenForLeadFormSuccess
  | GetTokenForLeadFormFailure
  | ClearGetTokenForLeadFormErrors
  | GetPresentationInfoRequest
  | GetPresentationInfoSuccess
  | GetPresentationInfoFailure
  | ClearGetPresentationInfo
  | GetEnrolleesRequest
  | GetEnrolleesSuccess
  | GetEnrolleesFailure
  | ClearGetEnrollees
  | GetEnrolleesInPresentationRequest
  | GetEnrolleesInPresentationSuccess
  | GetEnrolleesInPresentationFailure
  | ClearGetEnrolleesInPresentation
  | GetLeadsRequest
  | GetLeadsSuccess
  | GetLeadsFailure
  | ClearGetLeads
  | GetLeadRequest
  | GetLeadSuccess
  | GetLeadFailure
  | ClearGetLeadErrors
  | GetLeadStatusesRequest
  | GetLeadStatusesSuccess
  | GetLeadStatusesFailure
  | ClearGetLeadStatusesErrors
  | GetTasksRequest
  | GetTasksSuccess
  | GetTasksFailure
  | ClearGetTasksErrors
  | GetTaskRequest
  | GetTaskSuccess
  | GetTaskFailure
  | ClearGetTaskErrors
  | GetTaskFilesRequest
  | GetTaskFilesSuccess
  | GetTaskFilesFailure
  | ClearGetTaskFilesErrors
  | GetContractCredentialsRequest
  | GetContractCredentialsSuccess
  | GetContractCredentialsFailure
  | ClearGetContractCredentialsErrors
  | GetLeadDocumentsRequest
  | GetLeadDocumentsSuccess
  | GetLeadDocumentsFailure
  | ClearGetLeadDocumentsErrors
  | GetLeadContractRequest
  | GetLeadContractSuccess
  | GetLeadContractFailure
  | ClearGetLeadContractErrors
  | GetAllSalesDealsRequest
  | GetAllSalesDealsSuccess
  | GetAllSalesDealsFailure
  | ClearGetAllSalesDealsErrors
  | GetOneDealByIDRequest
  | GetOneDealByIDSuccess
  | GetOneDealByIDFailure
  | GetAllPaymentsRequest
  | GetAllPaymentsSuccess
  | GetAllPaymentsFailure
  | ClearGetAllPaymentsErrors
  | GetFullViewOfPaymentRequest
  | GetFullViewOfPaymentSuccess
  | GetFullViewOfPaymentFailure
  | ClearGetFullViewOfPaymentErrors
  | ClearGetOneDealByIDErrors
  | GetAllDiscountsRequest
  | GetAllDiscountsSuccess
  | GetAllDiscountsFailure
  | GetApplicantsRequest
  | GetApplicantsSuccess
  | GetApplicantsSFailure
  | GetLeadInQRRequest
  | GetLeadInQRSuccess
  | GetLeadInQRFailure
  | ClearGetLeadInQR
  | GetDealHistoryRequest
  | GetDealHistorySuccess
  | GetDealHistoryFailure
  | ClearGetDealHistory;
